import React from "react";
import { useCurrentFrame } from "remotion";

interface SubtitleWord {
  word: string;
  startMs: number;
  endMs: number;
}

interface SpatialCaptionsProps {
  subtitles: SubtitleWord[];
}

export const SpatialCaptions: React.FC<SpatialCaptionsProps> = ({
  subtitles,
}) => {
  const frame = useCurrentFrame();
  const currentMs = (frame / 30) * 1000;

  // Gather active and nearby words to display in a neat, centered sliding viewport
  const activeWordIndex = subtitles.findIndex(
    (sub) => currentMs >= sub.startMs && currentMs <= sub.endMs,
  );

  // Fallback to closest word if in a breathing gap
  const currentIndex =
    activeWordIndex !== -1
      ? activeWordIndex
      : subtitles.findIndex((sub) => sub.startMs > currentMs);

  const safeIndex = currentIndex !== -1 ? currentIndex : subtitles.length - 1;

  // Window viewport slice (displays active word plus 1 before and 1 after for standard speech pacing)
  const startIdx = Math.max(0, safeIndex - 1);
  const endIdx = Math.min(subtitles.length - 1, safeIndex + 1);
  const visibleWords = subtitles.slice(startIdx, endIdx + 1);

  return (
    <div
      style={{
        width: "100%",
        height: "140px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        padding: "0 20px",
      }}
    >
      {visibleWords.map((item, idx) => {
        const globalIdx = startIdx + idx;
        const isActive = globalIdx === activeWordIndex;

        return (
          <div
            key={globalIdx}
            style={{
              display: "inline-block",
              position: "relative",
              fontFamily: "'Orbitron', sans-serif",
              fontWeight: 900,
              fontSize: isActive ? "44px" : "36px",
              textTransform: "uppercase",
              letterSpacing: "1px",
              color: isActive ? "#ffffff" : "rgba(255, 255, 255, 0.25)",
              textShadow: isActive
                ? "0 0 15px rgba(0, 242, 254, 0.7), 0 0 30px rgba(255, 0, 127, 0.4)"
                : "none",
              transform: isActive ? "scale(1.15)" : "scale(1)",
              transition: "all 0.1s ease-out",
              padding: "4px 8px",
            }}
          >
            {item.word}

            {/* Active glowing indicator horizontal bar underneath the word */}
            {isActive && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-6px",
                  left: "10%",
                  right: "10%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ff007f, #00f2fe)",
                  boxShadow: "0 0 10px #00f2fe",
                  borderRadius: "2px",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
